export enum NaturalPersonMemberOrParent {
  Member = "Member",
  Parent = "Parent",
}

export enum NaturalPersonRelatedMemberType {
  Spouse = "Spouse",
  Son = "Son",
  Daughter = "Daughter",
  Father = "Father",
  Mother = "Mother",
  Sister = "Sister",
  Brother = "Brother",
  Cousin = "Cousin",
  // new relationships
  GrandmotherGrandfather = "GrandmotherGrandfather",
  MotherFather = "MotherFather",
  Child = "Child",
  Grandchild = "Grandchild",
  SisterBrother = "SisterBrother",
  NieceNephew = "NieceNephew",
}

export enum OldRelationshipTypes {
  Son = "Son",
  Daughter = "Daughter",
  Father = "Father",
  Mother = "Mother",
  Sister = "Sister",
  Brother = "Brother",
  Cousin = "Cousin",
}
